import { QuestionType2UIConfig } from "../../../../../components/ui/question-type2-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../../../../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import Scenario2NonAffiliatedStudents, { scenario2NonAffiliatedStudentsAudioCaching, scenario2NonAffiliatedStudentsVideoSegments } from "../../../scenario2-non-affiliated-students";
import { NonAffiliatedStudentsComponentsStep1ComponentMainConfig, NonAffiliatedStudentsComponentsStep1ComponentPart1Config } from "../non-affiliated-students-components-step1";

export default class NonAffiliatedStudentsComponentsStep1Part1 extends BaseScenarioPart<GameBaseScenario> {
	private stepName = 'Step 2'
	private get config(): NonAffiliatedStudentsComponentsStep1ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: NonAffiliatedStudentsComponentsStep1ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
        this.mainConfig.scenario.setAreaForCurrentScenario(6);
		this.mainConfig.scenario.uiWrapper.displayMixedMediaUI({
			title: this.mainConfig.scenario.props.name,
			subtitle: this.stepName,
			htmlData: `
				<p class="default-text add-pad">For the substitution test, you approach other employees and inquire as to whether they would do the same 
				thing in similar circumstances.<br/><br/>
				Respiratory Therapist #1: Don’t you need to make sure the students are authorized to be 
				here? I believe they need to get approval from the hospital. Then you assign them to us to precept.<br/><br/>
				Respiratory Therapist #2: Everyone knows that we aren’t allowed to bring in anyone into 
				our work setting that shouldn’t be here.<br/><br/>
				Respiratory Therapist #3: Yes, I am aware of this policy. I know that students must be 
				authorized by the Education Department. We have discussed this in the past several times.</p>
			`,
			okButton: 'Continue',
			talkingVideoSrc: scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('MixedMedia').src,
			talkingVideoChapterId: scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('MixedMedia').chapterIds[0],
			onContinueClicked: () => {
				context.section2();
			}
		})
	}

	public section2() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType2UI({
			title: this.mainConfig.scenario.props.name,
			audioUrl: scenario2NonAffiliatedStudentsAudioCaching.getItemByKey(scenario2NonAffiliatedStudentsAudioCaching.audioKeys.question3).src,
			subtitle: (this.stepName + ' - Question 1'),
			isYesCorrect: false,
			correctFeedback: `
				<p class="default-text">Correct. All other Respiratory Therapists said they would never bring students to a hospital without the appropriate authorization.</p>
			`,
			wrongFeedback: `
				<p class="default-text">Not the best option. The other Respiratory Therapists stated they would never bring students to a VA hospital.</p>
			`,
			question: 'Given the information received from staff interviews, is it reasonable to conclude that a systems or cultural issue exists, and other employees in that work area would behave the same way in a similar situation?',
			onSubmitClicked: (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
				const mentorInfo = scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType2(isCorrect, feedback, selectedTitle, (this.stepName + ' - Question 1 '), parentQuestion, () => {
					context.section3();
				}, () => {
					context.section3();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[6], mentorInfo.chapterIds[7]);
			}
		},2);
	}

	public section3() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 2'),
			audioUrl: scenario2NonAffiliatedStudentsAudioCaching.getItemByKey(scenario2NonAffiliatedStudentsAudioCaching.audioKeys.question4).src,
			questionTitle: 'Based on the substitution test, the accountability for this action…',
			options: [
				{
					title: 'Lies completely with the employee.',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">Correct. The substitution test demonstrates that no other 
						employees would make a similar choice and there are no system or cultural issues 
						identified. Accountability for the employee’s choice rests completely with them.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				},
				{
					title: 'Is shared between the employee and organizational leadership.',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option. The substitution test demonstrates 
						that no other employees would make a similar choice and there are no system or cultural 
						issues identified. Accountability for the employee’s choice rests completely with them.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Lies solely with the leadership.',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option. The substitution test demonstrates 
						that there are no system or cultural issues identified. Accountability for the 
						employee’s choice rests completely with them.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 2 '), parentQuestionConfig, () => {
					this.onDone();
				}, () => {
					this.onDone();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[8], mentorInfo.chapterIds[9], mentorInfo.chapterIds[10], 'Is shared between the employee and organizational leadership.');
			}
		}, 3);
	}
}